import { EventOf, EventSource } from "@baseline/runtime/events";
import { useEffect, useMemo } from "react";


export function useListener<S extends EventSource, A = any>(eventSource: S, event: EventOf<S>, listener: (arg?: A) => void): void;
// export function useListener<K extends keyof WindowEventMap, T extends Window = Window>(emitter: Window, type: K, listener: (this: Window, ev: WindowEventMap[K]) => any, options?: boolean | AddEventListenerOptions): void;
export function useListener(eventSource: EventSource | Window, event: string, listener: (arg?: any) => void): void
{
    const context = useMemo<Context>(() => ({}), []);

    // Using memo here to start listening immediately
    useMemo(() => { unsubscribe(); subscribe(); }, [eventSource, event, listener]);
    useEffect(() => unsubscribe, []);

    function subscribe()
    {
        Object.assign(context, { eventSource, event, listener });
        if (!eventSource || !listener)
            return;
        if (eventSource instanceof Window)
            eventSource.addEventListener(event, listener);
        else
            eventSource.on(event, listener);
    }

    function unsubscribe()
    {
        const { eventSource, event, listener } = context;

        if (!eventSource || !listener)
            return;

        if (eventSource instanceof Window)
            eventSource.removeEventListener(event, listener);
        else
            eventSource.off(event, listener);

        delete context.eventSource;
        delete context.event;
        delete context.listener;
    }
}

interface Context
{
    eventSource?: EventSource | Window;
    event?: string;
    listener?: (event: Event) => void;
}
